import { Box, DropdownButton, Flex, SubTitle } from "@shared/primitive-components"
import { localDateTimesToStartEnd } from "@shared/utils/formatters/dates"
import { useLDFlags } from "@shared/integration/launchdarkly"
import { usePolicyAndFleet } from "../../contexts"
import { previousPolicyDropdownStyles as styles } from "../styles"

export const PREV_POLICIES_DROPDOWN_DTI = {
  CONTAINER: `prev_policies_dropdown_container`,
  OPTION: `prev_policies_dropdown_option`,
  CURRENT: `prev_policies_dropdown_current`,
  BUTTON: `prev_policies_dropdown_button`,
}

export const PrevPolicyDropdown = () => {
  const { policy, prevPolicies, reloadPolicy } = usePolicyAndFleet()
  const { showPolicyDropdown } = useLDFlags()

  if (!showPolicyDropdown || !policy || !reloadPolicy || !prevPolicies || prevPolicies?.length < 2) return null
  const { id: selectedId, startTime, endTime } = policy

  const currentPolicy = prevPolicies[0]
  const currentPolicyValue = currentPolicy ? `${currentPolicy.id},${currentPolicy.userId}` : null

  const items = prevPolicies
    .filter((x) => x.id !== currentPolicy.id)
    .map((prevPolicy, i) => {
      const { id, startTime: start, endTime: end, userId } = prevPolicy
      const value = `${id},${userId}`
      return {
        value,
        text: `${localDateTimesToStartEnd(start, end)}`,
        "data-testid": `${PREV_POLICIES_DROPDOWN_DTI.OPTION}-${i}`,
      }
    })

  const dropdownButtonProps = {
    defaultDisplayValue:
      selectedId === currentPolicy.id ? `Current` : `${localDateTimesToStartEnd(startTime, endTime)}`,
    value: selectedId,
    action: (idUser: string | null) => {
      if (idUser) {
        const [policyId, userId] = idUser.split(`,`)
        reloadPolicy({
          policyId,
          userId,
        })
      }
    },
    firstItem: currentPolicyValue
      ? {
          text: `Current`,
          value: currentPolicyValue,
          dataTestId: PREV_POLICIES_DROPDOWN_DTI.CURRENT,
        }
      : undefined,
    items,
    dataTestIds: {
      button: PREV_POLICIES_DROPDOWN_DTI.BUTTON,
    },
    matchByDisplay: true,
  }

  return (
    <Box css={styles.prevPolicyContainer} data-testid={PREV_POLICIES_DROPDOWN_DTI.CONTAINER}>
      <Flex alignItems="center">
        <SubTitle css={styles.prevPolicyTitle}>Policy Period:</SubTitle>
        <Box>
          <DropdownButton {...dropdownButtonProps} variant="filter" />
        </Box>
      </Flex>
    </Box>
  )
}
